{
  "count": 33,
  "mode": "ZX Spectrum software-composited sprite",
  "validator": "/Users/zrebec/.codex/skills/zx-spectrum-screen/scripts/zx_sprite.py",
  "sprites": [
    {
      "name": "mini-rear-far",
      "family": "traffic",
      "role": "mini-rear",
      "lod": "far",
      "w": 7,
      "h": 6,
      "files": {
        "rows": "traffic/mini-rear-far.rows.txt",
        "json": "traffic/mini-rear-far.json",
        "native": "traffic/mini-rear-far.png",
        "preview4x": "traffic/mini-rear-far_4x.png"
      }
    },
    {
      "name": "mini-rear-mid",
      "family": "traffic",
      "role": "mini-rear",
      "lod": "mid",
      "w": 14,
      "h": 11,
      "files": {
        "rows": "traffic/mini-rear-mid.rows.txt",
        "json": "traffic/mini-rear-mid.json",
        "native": "traffic/mini-rear-mid.png",
        "preview4x": "traffic/mini-rear-mid_4x.png"
      }
    },
    {
      "name": "mini-rear-near",
      "family": "traffic",
      "role": "mini-rear",
      "lod": "near",
      "w": 28,
      "h": 22,
      "files": {
        "rows": "traffic/mini-rear-near.rows.txt",
        "json": "traffic/mini-rear-near.json",
        "native": "traffic/mini-rear-near.png",
        "preview4x": "traffic/mini-rear-near_4x.png"
      }
    },
    {
      "name": "mini-front-far",
      "family": "traffic",
      "role": "mini-front",
      "lod": "far",
      "w": 7,
      "h": 6,
      "files": {
        "rows": "traffic/mini-front-far.rows.txt",
        "json": "traffic/mini-front-far.json",
        "native": "traffic/mini-front-far.png",
        "preview4x": "traffic/mini-front-far_4x.png"
      }
    },
    {
      "name": "mini-front-mid",
      "family": "traffic",
      "role": "mini-front",
      "lod": "mid",
      "w": 14,
      "h": 11,
      "files": {
        "rows": "traffic/mini-front-mid.rows.txt",
        "json": "traffic/mini-front-mid.json",
        "native": "traffic/mini-front-mid.png",
        "preview4x": "traffic/mini-front-mid_4x.png"
      }
    },
    {
      "name": "mini-front-near",
      "family": "traffic",
      "role": "mini-front",
      "lod": "near",
      "w": 28,
      "h": 22,
      "files": {
        "rows": "traffic/mini-front-near.rows.txt",
        "json": "traffic/mini-front-near.json",
        "native": "traffic/mini-front-near.png",
        "preview4x": "traffic/mini-front-near_4x.png"
      }
    },
    {
      "name": "car-rear-far",
      "family": "traffic",
      "role": "car-rear",
      "lod": "far",
      "w": 11,
      "h": 8,
      "files": {
        "rows": "traffic/car-rear-far.rows.txt",
        "json": "traffic/car-rear-far.json",
        "native": "traffic/car-rear-far.png",
        "preview4x": "traffic/car-rear-far_4x.png"
      }
    },
    {
      "name": "car-rear-mid",
      "family": "traffic",
      "role": "car-rear",
      "lod": "mid",
      "w": 22,
      "h": 15,
      "files": {
        "rows": "traffic/car-rear-mid.rows.txt",
        "json": "traffic/car-rear-mid.json",
        "native": "traffic/car-rear-mid.png",
        "preview4x": "traffic/car-rear-mid_4x.png"
      }
    },
    {
      "name": "car-rear-near",
      "family": "traffic",
      "role": "car-rear",
      "lod": "near",
      "w": 44,
      "h": 30,
      "files": {
        "rows": "traffic/car-rear-near.rows.txt",
        "json": "traffic/car-rear-near.json",
        "native": "traffic/car-rear-near.png",
        "preview4x": "traffic/car-rear-near_4x.png"
      }
    },
    {
      "name": "car-front-far",
      "family": "traffic",
      "role": "car-front",
      "lod": "far",
      "w": 11,
      "h": 8,
      "files": {
        "rows": "traffic/car-front-far.rows.txt",
        "json": "traffic/car-front-far.json",
        "native": "traffic/car-front-far.png",
        "preview4x": "traffic/car-front-far_4x.png"
      }
    },
    {
      "name": "car-front-mid",
      "family": "traffic",
      "role": "car-front",
      "lod": "mid",
      "w": 22,
      "h": 15,
      "files": {
        "rows": "traffic/car-front-mid.rows.txt",
        "json": "traffic/car-front-mid.json",
        "native": "traffic/car-front-mid.png",
        "preview4x": "traffic/car-front-mid_4x.png"
      }
    },
    {
      "name": "car-front-near",
      "family": "traffic",
      "role": "car-front",
      "lod": "near",
      "w": 44,
      "h": 30,
      "files": {
        "rows": "traffic/car-front-near.rows.txt",
        "json": "traffic/car-front-near.json",
        "native": "traffic/car-front-near.png",
        "preview4x": "traffic/car-front-near_4x.png"
      }
    },
    {
      "name": "bus-rear-far",
      "family": "traffic",
      "role": "bus-rear",
      "lod": "far",
      "w": 14,
      "h": 9,
      "files": {
        "rows": "traffic/bus-rear-far.rows.txt",
        "json": "traffic/bus-rear-far.json",
        "native": "traffic/bus-rear-far.png",
        "preview4x": "traffic/bus-rear-far_4x.png"
      }
    },
    {
      "name": "bus-rear-mid",
      "family": "traffic",
      "role": "bus-rear",
      "lod": "mid",
      "w": 28,
      "h": 18,
      "files": {
        "rows": "traffic/bus-rear-mid.rows.txt",
        "json": "traffic/bus-rear-mid.json",
        "native": "traffic/bus-rear-mid.png",
        "preview4x": "traffic/bus-rear-mid_4x.png"
      }
    },
    {
      "name": "bus-rear-near",
      "family": "traffic",
      "role": "bus-rear",
      "lod": "near",
      "w": 56,
      "h": 36,
      "files": {
        "rows": "traffic/bus-rear-near.rows.txt",
        "json": "traffic/bus-rear-near.json",
        "native": "traffic/bus-rear-near.png",
        "preview4x": "traffic/bus-rear-near_4x.png"
      }
    },
    {
      "name": "bus-front-far",
      "family": "traffic",
      "role": "bus-front",
      "lod": "far",
      "w": 14,
      "h": 9,
      "files": {
        "rows": "traffic/bus-front-far.rows.txt",
        "json": "traffic/bus-front-far.json",
        "native": "traffic/bus-front-far.png",
        "preview4x": "traffic/bus-front-far_4x.png"
      }
    },
    {
      "name": "bus-front-mid",
      "family": "traffic",
      "role": "bus-front",
      "lod": "mid",
      "w": 28,
      "h": 18,
      "files": {
        "rows": "traffic/bus-front-mid.rows.txt",
        "json": "traffic/bus-front-mid.json",
        "native": "traffic/bus-front-mid.png",
        "preview4x": "traffic/bus-front-mid_4x.png"
      }
    },
    {
      "name": "bus-front-near",
      "family": "traffic",
      "role": "bus-front",
      "lod": "near",
      "w": 56,
      "h": 36,
      "files": {
        "rows": "traffic/bus-front-near.rows.txt",
        "json": "traffic/bus-front-near.json",
        "native": "traffic/bus-front-near.png",
        "preview4x": "traffic/bus-front-near_4x.png"
      }
    },
    {
      "name": "deciduous-far",
      "family": "roadside",
      "role": "deciduous",
      "lod": "far",
      "w": 8,
      "h": 12,
      "files": {
        "rows": "roadside/deciduous-far.rows.txt",
        "json": "roadside/deciduous-far.json",
        "native": "roadside/deciduous-far.png",
        "preview4x": "roadside/deciduous-far_4x.png"
      }
    },
    {
      "name": "conifer-far",
      "family": "roadside",
      "role": "conifer",
      "lod": "far",
      "w": 8,
      "h": 12,
      "files": {
        "rows": "roadside/conifer-far.rows.txt",
        "json": "roadside/conifer-far.json",
        "native": "roadside/conifer-far.png",
        "preview4x": "roadside/conifer-far_4x.png"
      }
    },
    {
      "name": "rocks-far",
      "family": "roadside",
      "role": "rocks",
      "lod": "far",
      "w": 8,
      "h": 5,
      "files": {
        "rows": "roadside/rocks-far.rows.txt",
        "json": "roadside/rocks-far.json",
        "native": "roadside/rocks-far.png",
        "preview4x": "roadside/rocks-far_4x.png"
      }
    },
    {
      "name": "sign-far",
      "family": "roadside",
      "role": "sign",
      "lod": "far",
      "w": 8,
      "h": 12,
      "files": {
        "rows": "roadside/sign-far.rows.txt",
        "json": "roadside/sign-far.json",
        "native": "roadside/sign-far.png",
        "preview4x": "roadside/sign-far_4x.png"
      }
    },
    {
      "name": "lamp-far",
      "family": "roadside",
      "role": "lamp",
      "lod": "far",
      "w": 3,
      "h": 8,
      "files": {
        "rows": "roadside/lamp-far.rows.txt",
        "json": "roadside/lamp-far.json",
        "native": "roadside/lamp-far.png",
        "preview4x": "roadside/lamp-far_4x.png"
      }
    },
    {
      "name": "deciduous-mid",
      "family": "roadside",
      "role": "deciduous",
      "lod": "mid",
      "w": 16,
      "h": 24,
      "files": {
        "rows": "roadside/deciduous-mid.rows.txt",
        "json": "roadside/deciduous-mid.json",
        "native": "roadside/deciduous-mid.png",
        "preview4x": "roadside/deciduous-mid_4x.png"
      }
    },
    {
      "name": "conifer-mid",
      "family": "roadside",
      "role": "conifer",
      "lod": "mid",
      "w": 16,
      "h": 24,
      "files": {
        "rows": "roadside/conifer-mid.rows.txt",
        "json": "roadside/conifer-mid.json",
        "native": "roadside/conifer-mid.png",
        "preview4x": "roadside/conifer-mid_4x.png"
      }
    },
    {
      "name": "rocks-mid",
      "family": "roadside",
      "role": "rocks",
      "lod": "mid",
      "w": 16,
      "h": 10,
      "files": {
        "rows": "roadside/rocks-mid.rows.txt",
        "json": "roadside/rocks-mid.json",
        "native": "roadside/rocks-mid.png",
        "preview4x": "roadside/rocks-mid_4x.png"
      }
    },
    {
      "name": "sign-mid",
      "family": "roadside",
      "role": "sign",
      "lod": "mid",
      "w": 16,
      "h": 24,
      "files": {
        "rows": "roadside/sign-mid.rows.txt",
        "json": "roadside/sign-mid.json",
        "native": "roadside/sign-mid.png",
        "preview4x": "roadside/sign-mid_4x.png"
      }
    },
    {
      "name": "lamp-mid",
      "family": "roadside",
      "role": "lamp",
      "lod": "mid",
      "w": 5,
      "h": 16,
      "files": {
        "rows": "roadside/lamp-mid.rows.txt",
        "json": "roadside/lamp-mid.json",
        "native": "roadside/lamp-mid.png",
        "preview4x": "roadside/lamp-mid_4x.png"
      }
    },
    {
      "name": "deciduous-near",
      "family": "roadside",
      "role": "deciduous",
      "lod": "near",
      "w": 32,
      "h": 48,
      "files": {
        "rows": "roadside/deciduous-near.rows.txt",
        "json": "roadside/deciduous-near.json",
        "native": "roadside/deciduous-near.png",
        "preview4x": "roadside/deciduous-near_4x.png"
      }
    },
    {
      "name": "conifer-near",
      "family": "roadside",
      "role": "conifer",
      "lod": "near",
      "w": 32,
      "h": 48,
      "files": {
        "rows": "roadside/conifer-near.rows.txt",
        "json": "roadside/conifer-near.json",
        "native": "roadside/conifer-near.png",
        "preview4x": "roadside/conifer-near_4x.png"
      }
    },
    {
      "name": "rocks-near",
      "family": "roadside",
      "role": "rocks",
      "lod": "near",
      "w": 32,
      "h": 20,
      "files": {
        "rows": "roadside/rocks-near.rows.txt",
        "json": "roadside/rocks-near.json",
        "native": "roadside/rocks-near.png",
        "preview4x": "roadside/rocks-near_4x.png"
      }
    },
    {
      "name": "sign-near",
      "family": "roadside",
      "role": "sign",
      "lod": "near",
      "w": 24,
      "h": 32,
      "files": {
        "rows": "roadside/sign-near.rows.txt",
        "json": "roadside/sign-near.json",
        "native": "roadside/sign-near.png",
        "preview4x": "roadside/sign-near_4x.png"
      }
    },
    {
      "name": "lamp-near",
      "family": "roadside",
      "role": "lamp",
      "lod": "near",
      "w": 9,
      "h": 32,
      "files": {
        "rows": "roadside/lamp-near.rows.txt",
        "json": "roadside/lamp-near.json",
        "native": "roadside/lamp-near.png",
        "preview4x": "roadside/lamp-near_4x.png"
      }
    }
  ]
}
